module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-show/dialog-show.component.css
// module id = ./src/app/dialog-show/dialog-show.component.css
// module chunks = main